<template>
    <div class="editor_scene" :style="colors">
        <div class="editor_scene-title">
            <h1>{{ $t('editorPlaceholdersTitle') }}</h1>
        </div>
        <div class="placeholders_list">
            <div class="placeholders_list-title">
                <div class="placeholder_name">
                    {{ $t('editorPlaceholdersName') }}
                </div>
                <div class="placeholder_system_name">
                    {{ $t('editorPlaceholdersSystemName') }}
                </div>
            </div>
            <div
                class="placeholders_list-item"
                v-for="placeholder in placeholdersList"
                :key="placeholder.id"
                @click="injectPlaceholderToUpdateData(placeholder)"
            >
                <div class="placeholder_name">
                    {{ placeholder.name }}
                </div>
                <div class="placeholder_system_name">
                    {{ placeholder.systemName }}
                </div>
            </div>
        </div>
        <button
            @click="showPlaceholderModal = true"
            class="button add_new_placeholder"
        >
            {{ $t('editorPlaceholdersAddNew') }}
        </button>
        <Modal 
            v-if="showPlaceholderModal"
            @close="showPlaceholderModal = false"
        >
            <template v-slot:header>
                {{ $t('editorPlaceholdersCreateNew') }}
            </template>
            <template v-slot:body>
                <form method="post" action="?" @submit.prevent="addNewPlaceholder" class="modalForm">
                    <div class="form-group">
                        <label for="placeholderName">{{ $t('editorPlaceholdersName') }}</label>
                        <input
                            id="placeholderName"
                            v-model="placeholderName"
                            type="text"
                            name="placeholderName"
                        />
                    </div>
                    <div class="form-group">
                        <label for="placeholderSystemName">{{ $t('editorPlaceholdersSystemName') }}</label>
                        <input
                            id="placeholderSystemName"
                            v-model="placeholderSystemName"
                            type="text"
                            name="placeholderSystemName"
                        />
                    </div>
                    <div class="form-footer">
                        <button @click="showPlaceholderModal = false" class="button modal_cancel-btn">{{ $t('editorCancel') }}</button>
                        <button
                            type="submit"
                            class="button main_btn form_submit_btn"
                        >{{ $t('editorSubmit') }}</button>
                    </div>
                </form>
            </template>
        </Modal>
        <Modal 
            v-if="showPlaceholderUpdateModal"
            @close="showPlaceholderUpdateModal = false"
            :style="colors"
        >
            <template v-slot:header>
                {{ $t('editorPlaceholdersUpdate') }}
            </template>
            <template v-slot:body>
                <form method="post" action="?" @submit.prevent="updatePlaceholder" class="modalForm">
                    <div class="form-group">
                        <label for="placeholderName">{{ $t('editorPlaceholdersName') }}</label>
                        <input
                            id="placeholderName"
                            v-model="placeholderName"
                            type="text"
                            name="placeholderName"
                        />
                    </div>
                    <div class="form-group">
                        <label for="placeholderSystemName">{{ $t('editorPlaceholdersSystemName') }}</label>
                        <input
                            id="placeholderSystemName"
                            v-model="placeholderSystemName"
                            type="text"
                            name="placeholderSystemName"
                            disabled
                        />
                    </div>
                    <div class="form-footer">
                        <button @click="closeUpdatePlaceholderModal" class="button modal_cancel-btn">{{ $t('editorCancel') }}</button>
                        <button @click="removePlaceholder" class="button">{{ $t('editorPlaceholdersRemove') }}</button>
                        <button
                            type="submit"
                            class="button main_btn form_submit_btn"
                        >{{ $t('editorSubmit') }}</button>
                    </div>
                </form>
            </template>
        </Modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { RepositoryFactory } from '../../repositories/repositoryFactory';
    const PlaceholderRepository = RepositoryFactory.get('placeholders');

    import Modal from '@/components/Global/Modal.vue';

    export default {
        data() {
            return {
                showPlaceholderModal: false,
                placeholderName: null,
                placeholderSystemName: null,
                placeholdersList: [],
                showPlaceholderUpdateModal: false,
                placeholderToUpdateId: null
            }
        },
        methods: {
            async addNewPlaceholder() {
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.getSessionDetails.token
                }

                const payload = {
                    name: this.placeholderName,
                    systemName: this.placeholderSystemName,
                    type: "text"
                }

                try {
                    const createPlaceholder = await PlaceholderRepository.addPlaceholder(payload, headers);
                    const newPlaceholderData = createPlaceholder.data.data;
                    this.placeholdersList = [...this.placeholdersList, newPlaceholderData];
                }
                catch(err) {
                    console.log(err)
                }

                this.showPlaceholderModal = false;
                this.placeholderName = null;
                this.placeholderSystemName = null;
            },
            injectPlaceholderToUpdateData(placeholder) {
                this.showPlaceholderUpdateModal = true;
                this.placeholderName = placeholder.name;
                this.placeholderSystemName = placeholder.systemName;
                this.placeholderToUpdateId = placeholder.id;
            },
            closeUpdatePlaceholderModal() {
                this.showPlaceholderUpdateModal = false;
                this.placeholderName = null;
                this.placeholderSystemName = null;
                this.placeholderToUpdateId = null;
            },
            async updatePlaceholder() {
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.getSessionDetails.token
                }

                const payload = {
                    id: this.placeholderToUpdateId,
                    name: this.placeholderName,
                    systemName: this.placeholderSystemName,
                    type: "text"
                }

                try {
                    const updatePlaceholder = await PlaceholderRepository.updatePlaceholder(payload, headers);
                    let placeholderToUpdate = this.placeholdersList.find(placeholder => placeholder.id === this.placeholderToUpdateId);
                    placeholderToUpdate.name = updatePlaceholder.data.data.name;
                    placeholderToUpdate.systemName = updatePlaceholder.data.data.systemName;                    
                }
                catch(err) {
                    console.log(err)
                }

                this.closeUpdatePlaceholderModal();
            },
            async removePlaceholder() {
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.getSessionDetails.token
                }
                try {
                    const removePlaceholder = await PlaceholderRepository.removePlaceholder(this.placeholderToUpdateId, headers);
                    this.placeholdersList = this.placeholdersList.filter(placeholder => placeholder.id !== this.placeholderToUpdateId);                   
                }
                catch(err) {
                    console.log(err)
                }

                this.closeUpdatePlaceholderModal();
            }
        },
        computed: {
            ...mapGetters([
                'getSessionDetails'
            ]),
            colors() {
                return {
                    '--primary-color': `#${this.getSessionDetails.editorSetup.colors.primaryColor}`
                }
            }
        },
        async created() {
            const headers = {
                'api-key' : 'session',
                'api-sign' : this.getSessionDetails.token
            }

            try {
                const listPlaceholders = await PlaceholderRepository.getPlaceholders(headers);
                this.placeholdersList = listPlaceholders.data.data.entities;
            }
            catch(err) {
                console.log(err)
            }
        },
        components: {
            Modal
        }
    }
</script>

<style scoped>
    .editor_scene {
        flex-grow: 1;
    }
    .placeholders_list {
        width: 40%;
        display: grid;
        grid-template-columns: 100%;
        background-color: #EBEAEB;
        grid-gap: 1px;
    }
    .placeholders_list-item {
        cursor: pointer;
        background-color: #fff;
    }
    .placeholders_list-item:hover,
    .placeholders_list-title {
        color: #fff;
        background-color: var(--primary-color);
    }
    .placeholder_name,
    .placeholder_system_name {
        display: inline-block;
        padding: 5px 8px;
    }
    .placeholder_name {
        width: 50%;
        border-right: 1px solid #EBEAEB;
    }
    .add_new_placeholder {
        background-color: var(--primary-color);
        border-color: var(--primary-color);
        color: #FFF;
        display: inline-block;
        width: auto;
        margin: 20px 0;
        border-radius: 16px;
        padding: 6px 15px;
        cursor: pointer;
    }
    .add_new_placeholder:hover {
        opacity: 0.8;
    }
</style>